import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  trackSuburbanSaveSearchModalClose,
  trackSuburbanSaveSearchModalOpen,
  trackSuburbanSaveSearchSubscribed,
} from './tracking';
import { isSuburban, offerTypeFromJsonQuery } from '../../../../packages/JsonQuery';
import {
  SaveSearchContainer,
  TOnSubmitSaveSearchParams,
  useSaveSearchEvents,
} from '../../../../packages/SaveSearchModal';
import { selectQueryString } from '../../selectors/queryString';
import { selectResultsJsonQuery } from '../../selectors/results';

export const SaveSearchModalContainer: React.FC = () => {
  const jsonQuery = useSelector(selectResultsJsonQuery);
  const deviceType = useDeviceType();
  const queryString = useSelector(selectQueryString);
  const isSuburbanMap = React.useMemo(() => isSuburban(offerTypeFromJsonQuery(jsonQuery)), [jsonQuery]);

  const handleSubscribed = React.useCallback(
    (parameters: TOnSubmitSaveSearchParams) => {
      if (isSuburbanMap) {
        trackSuburbanSaveSearchSubscribed({
          ...parameters,
          deviceType,
          queryString,
        });
      }
    },
    [isSuburbanMap, deviceType, queryString],
  );

  const handleOpen = React.useCallback(() => {
    if (isSuburbanMap) {
      trackSuburbanSaveSearchModalOpen();
    }
  }, [isSuburbanMap]);

  const handleClose = React.useCallback(() => {
    if (isSuburbanMap) {
      trackSuburbanSaveSearchModalClose();
    }
  }, [isSuburbanMap]);

  useSaveSearchEvents(handleSubscribed, handleOpen, handleClose);

  return <SaveSearchContainer />;
};
